import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';

export class ReportTemplateModel extends WithoutSummaryModel{
    name: string;
    path: string;
}

